module.exports = __webpack_public_path__ + "static/img/son5.23968e61.png";